let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("57yIp")).then(() => parcelRequire('hX1AL'));